import { ADD_SPARKED_ADDRESS } from "./sparkedAddressReducer"

export const addSparkedAddress = (address) => ({
    type: ADD_SPARKED_ADDRESS,
    payload: address
})